import React from 'react';
import { useTranslation } from 'react-i18next';

import EmptyData from 'components/EmptyData';
import NewsItem from 'modules/News/components/NewsItem';

import EmptyNewsSvg from '@common/assets/icons/empty-data-news.svg';
import { INewsItemModel } from '@common/models/News/NewsItem';

import { NewsSectionWrap } from './styled';

interface PropsType {
	news: INewsItemModel[];
}

function NewsSection({ news }: PropsType) {
	const { t } = useTranslation();
	if (!news || news.length <= 0) {
		return (
			<EmptyData
				icon={<EmptyNewsSvg />}
				title={t('news.emptyDataTitle')}
				subTitle={t('news.emptyDataDescription')}
			/>
		);
	}

	return (
		<NewsSectionWrap>
			{news.map((newsItem) => (
				<NewsItem newsItem={newsItem} key={newsItem.id} />
			))}
		</NewsSectionWrap>
	);
}

export default NewsSection;
